import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init } from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const Result = Loadable({
    loader: () => import('./Result'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          topUpAutoRechargeResultState: state.topUpAutoRechargeResultState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          languageChange
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/result`}
      render={(routeProps) => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Result {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
